import { getEnvVar } from '@mc/client-env'
import { EventTypes } from './constants'

/**
 * Checks if Segment analytics can make API calls to send events (i.e., if tracking cookies are enabled)
 * @returns true if Segment SDK is loaded and initialized, false otherwise
 */
export const isSegmentSendingEvents = (): boolean => {
  try {
    if (typeof window === 'undefined' || !window.analytics) {
      return false
    }

    // Check if we're in the real SDK state (not just the snippet stub)
    // If window.analytics is an Array or has SNIPPET_VERSION/invoked, we're in queue-only mode
    // If window.analytics is an Object with initialized: true, the SDK is loaded and sending
    const analytics = window.analytics as unknown as Record<string, unknown>
    const isActuallySending =
      !Array.isArray(analytics) && analytics?.initialized === true

    return isActuallySending
  } catch (error) {
    // If there's any error checking Segment, assume it's not functional
    return false
  }
}

export const logSegmentCalls = (
  type: string,
  event: string,
  inputProperties?: Record<string, unknown>,
  options?: object,
) => {
  const logEnv = getEnvVar('LOG_SEGMENT_CALLS')
  if (logEnv === true || logEnv === 'true') {
    let output = `analytics.${type}('${event}'`
    if (inputProperties) {
      output += `, ${JSON.stringify(inputProperties, null, 2)}`
    }
    if (options && Object.keys(options).length) {
      output += `, ${JSON.stringify(options, null, 2)}`
    }
    output += ')'

    if (
      event === EventTypes.EXPERIMENT_VIEWED &&
      inputProperties?.experimentName &&
      inputProperties?.variationName
    ) {
      // eslint-disable-next-line no-console
      console.groupCollapsed(
        `Segment event: ${event} (${inputProperties.experimentName}: ${inputProperties.variationName})`,
      )
    } else {
      console.groupCollapsed(`Segment event: ${event}`) // eslint-disable-line
    }

    console.info(`%c ${output}`, 'color: #59a2ea') // eslint-disable-line
    console.groupEnd() // eslint-disable-line
  }
}
